module.exports = "/packs/media/images/icons/Security-c88d721471d6dfe93e87d61fd0ae5b80.png";